import React, { forwardRef } from "react";

import ArrowRight from "images/icons/arrow-right.inline.svg";
import DownloadSvg from "images/icons/fi-rr-download.inline.svg";

import { Link } from "../../../utils/customLink";

// eslint-disable-next-line react/display-name
const CourseStickyBar = forwardRef(
  ({ courseBrochure, nextDate, programCode, applyNow, enquireNow }, ref) => {
    return (
      <div
        className="fixed hidden md:flex w-full md:z-20 border-0.5 border-gray-testimonial gvi-box-shadow transition-all duration-50 gvi-blur-bg !bg-gray-lighten/40"
        ref={ref}
      >
        <div className="gvi-container flex justify-between items-center mx-auto py-7">
          <a
            className="callback-button group flex justify-center items-center px-20 py-2 bg-white hover:bg-black-lighter hover:text-white planet:bg-transparent planet:hover:bg-white planet:hover:text-gray-darker"
            href={courseBrochure}
            target={"_gviblank"}
          >
            <div
              dangerouslySetInnerHTML={{ __html: "Download course info" }}
              className="pr-2"
            />

            <DownloadSvg className="w-5 pr-1 fill-black-lighter group-hover:fill-white planet:fill-white planet:group-hover:fill-gray-darker" />
          </a>

          <div className="flex gap-7 items-center">
            {nextDate && (
              <div
                dangerouslySetInnerHTML={{
                  __html: `Next start date: ${nextDate}`
                }}
                className="h3"
              />
            )}

            <div className="flex flex-col md:flex-row gap-3">
              <Link
                className="submit-button group flex basis-1/2 justify-center items-center px-14 py-2"
                to={`${
                  applyNow ??
                  `/application-form/?online_program&program_code=${programCode}`
                }`}
              >
                <div
                  dangerouslySetInnerHTML={{ __html: "Apply" }}
                  className="pr-2 font-bold"
                />
                <ArrowRight className="w-3 h-3 stroke-white planet:stroke-black-lighter group-hover:stroke-green-standard" />
              </Link>
              <Link
                className="callback-button group flex basis-1/2 justify-center items-center px-7 py-2 bg-white hover:bg-black-lighter hover:text-white planet:bg-transparent planet:hover:bg-white planet:hover:text-gray-darker"
                to={`${enquireNow ?? "#find-out-more"}`}
              >
                <div
                  dangerouslySetInnerHTML={{ __html: "Find out more" }}
                  className="pr-2 shrink-0"
                />
                <ArrowRight className="planet:hidden block w-3 h-3 stroke-black-lighter planet:stroke-white group-hover:stroke-white planet:group-hover:stroke-black-lighter" />
                <ArrowRight className="w-3 h-3 stroke-white group-hover:stroke-black-lighter hidden planet:block" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default CourseStickyBar;
